// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2UF_4","gfeWrapper":"CalendarEvent_gfeWrapper__dI8A8"};